import { IFilter } from "../Tools/IFilter";
import { FilterGroup } from "../Tools/FilterGroup";
import { OptionData, Options } from "select2";
import { checkAndDestroySelect2, globalMatcher, globalTemplateResult } from "../Tools/GlobalMethods";
import { FiltersController } from "../Tools/FiltersController";
import { FiltersWidget } from "../FiltersWidget";
import { StyleFilterWidget } from "../FiltersWidgets/StyleFilterWidget";

export class RoomTypeFilter implements IFilter {
    id: string;
    name?: string | null | undefined;
    type: string;
    source?: string | undefined;
    controller: FiltersController
    parentGroup: FilterGroup;

    constructor(parentGroup: FilterGroup) {
        this.parentGroup = parentGroup;
        this.id = 'roomType';
        this.name = 'Type de pièce';
        this.type = 'roomType';
        this.source = 'AM';
        this.controller = new FiltersController();
    }

    html(): string {
        let html = `
        <div class="filter" style="display: flex;flex-direction: column;align-items: center;margin:0 auto;max-width: 380px;width: 100%;">
            <span>${this.name}</span>
            <select id="roomTypeFilterSelect"
                style="text-align: left;width: 100%;" title="${this.name}">
            </select>
        </div>
        `;

        setTimeout(() => {
            FilterGroup.loadRoomTypes().then(() => {
                if (this.parentGroup.isDestroyed) return;
                checkAndDestroySelect2('#roomTypeFilterSelect');
                let rooms: any[] = (this.source === 'BO' ? FilterGroup.boRoomTypes : FilterGroup.roomTypes)!;
                rooms = rooms.map((element) => {
                    return {
                        id: element._id || '-1',
                        text: element.name,
                        title: this.name,
                        selected: FilterGroup.filters.roomType?.includes(element)
                    } as OptionData;
                });
                $('#roomTypeFilterSelect').select2({
                    placeholder: {
                        id: '-1',
                        text: 'Choisissez un type'
                    },
                    data: [
                        {
                            id: '-1',
                            text: 'Choisissez un type',
                        } as OptionData,
                        ...rooms,
                    ],
                    matcher: globalMatcher,
                    templateResult: globalTemplateResult,
                    multiple: true,
                    dropdownAutoWidth: true,
                    selectionCssClass: 'select-control',

                } as unknown as Options);
            });

            $('#roomTypeFilterSelect').on('change.select2', () => {
                let selectedValues = $('#roomTypeFilterSelect').val() as string[];
                if (selectedValues.length === 0 || selectedValues[0] === '-1') {
                    FilterGroup.filters.roomType = null;
                } else {
                    FilterGroup.filters.roomType = FilterGroup.roomTypes!.filter((element) => selectedValues.includes(element._id)) || null;
                }
                FilterGroup.getUpdateFunctions(this.parentGroup.filtersFunction)(FilterGroup.filters).then(() => {
                    if (FiltersWidget.currentFiltersGroup === this.parentGroup) {
                        if (this.parentGroup.id === 'style') {
                            let parent = this.parentGroup as StyleFilterWidget;
                            FilterGroup.changeProjectPage(FilterGroup.currentPage).then(() => {
                                parent.updateProjectResultsHtml();
                            });
                        }
                    }
                });
            });
        });
        return html;
    }

    generateStringFilter(): string {
        return("");
    }

    destroy(): void {
        $('#roomTypeFilterSelect').off('change.select2');
        checkAndDestroySelect2('#roomTypeFilterSelect');
        this.controller.destroy();
    }
}